import React from 'react'
import { MdInfo } from 'react-icons/md'
import { FaExclamationTriangle } from 'react-icons/fa'
import { IconContext } from 'react-icons'

import './lgy-tooltip.scss'

/**
 * An LGY-standard component for displaying a tooltip, a small icon that the user can hover over with their mouse or touch with their finger to display a small helpful contextual message
 * 
 * @author Alex Clary
 * @author Nic Ebner
 * @author Matt Frazier
 * 
 * @param {object} props Component props
 * @param {JSX} [props.message] essentially equivalent to props.children
 * @param {string} [props.id] a unique id for the tooltip message
 * @param {boolean} [props.useExclamation] whether to display an exclamation mark rather than a question mark icon 
 * @param {JSX} [props.children] describes the tooltip message
 *
 */
const LgyTooltip = ({ message, id, useExclamation, children }) =>
  <span className='lgy-tooltip' focusable='true' tabIndex='0'>
    {useExclamation 
      ? <IconContext.Provider value={{ className: 'tooltip-icon-exclamation' }} attr={{ focusable: 'false', tabIndex: '-1' }}>
          <FaExclamationTriangle size={18} alt='tooltip' style={{ verticalAlign: 'text-top', color: 'orangered' }} />
        </IconContext.Provider> 
      : <IconContext.Provider value={{ className: 'tooltip-icon-info' }} attr={{ focusable: 'false', tabIndex: '-1' }}>
          <MdInfo size={18} title='tooltip' style={{ verticalAlign: 'text-top', color: '#205493' }} />
        </IconContext.Provider>}
    <div className='wrap-tooltip-message'>
      <span id={id} className='tooltip-message' role='tooltip' style={{ color: 'black' }}>
        {message}
        {children}
      </span>
    </div>
  </span>

export default LgyTooltip